<template lang="pug">
.markeplaces
  .markeplaces__text
    div {{ $t('marketplace')[0] }}
    div {{ $t('marketplace')[1] }}
  .markeplaces__items
    a(href="https://www.wildberries.ru/catalog/781180087/detail.aspx?targetUrl=GP" target="_blank")
      img(src="~@/assets/img/header/banner/marmelade/wb.png" alt="wb")
    a(href="https://ozon.ru/t/aHmeUh5" target="_blank")
      img(src="~@/assets/img/header/banner/marmelade/ozon.png" alt="ozon")
</template>
<script>

export default {
  name: 'MarketplaceGummies'
}
</script>
